//angular imports
import { 
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ComponentRef,
    InputSignal, 
    effect, 
    input 
} from "@angular/core";

import { 
    CdkPortalOutletAttachedRef, 
    ComponentPortal 
} from "@angular/cdk/portal";

//local imports
import { PresenterHelper, PresenterModelKey } from "./presenter-type";
import { Transforms } from "@app/shared/helpers";

@Component({
    selector: "presenter",
    templateUrl: "./presenter.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PresenterComponent
{    
    public presenterOutlet: ComponentPortal<any>;
    
    public data: InputSignal<any> = input<any>();
    public key: InputSignal<string> = input<string>();
    public allowFallback = input(false, {
        transform: Transforms.toBoolean
      });
      

    constructor(cdf: ChangeDetectorRef) {

        effect(() =>
        {        
            let data = this.data();
            if (!data) return null;
                        
            let lookupKey: PresenterModelKey = { 
                model: data,
                key: this.key(),                
            }

            let template = PresenterHelper.getTemplate(lookupKey, this.allowFallback());

            if(!template) {
                return null;
            }
            this.presenterOutlet = new ComponentPortal(template);            
            
            cdf.markForCheck();
        });
    }

    public attached(ref: CdkPortalOutletAttachedRef)
    {
        ref = ref as ComponentRef<any>;
        ref.instance?.data?.set(this.data());        
    }
}